import { onLCP, onCLS, onFID, onTTFB, onINP } from "web-vitals";

import curry from "../lib/core/functional/curry";
import { waitForGtag } from "./ga4Stats";

const onGA = curry(function onGA({ name, delta, id }, gtag) {
    gtag("event", name, {
        event_category: "Web Vitals",
        event_label: id,
        value: Math.round(name === "CLS" ? delta * 1000 : delta),
        non_interaction: true,
    });
});

function sendToGA(report) {
    waitForGtag(onGA(report));
}

export default function initWebVitals() {
    const sampleRate = parseInt(window.REBELMOUSE_BOOTSTRAP_DATA.engine.webVitalsSampleRate, 10);
    const randomNumber = Math.floor(Math.random() * 101);
    if (randomNumber > sampleRate) {
        return;
    }

    onCLS(sendToGA);
    onFID(sendToGA);
    onLCP(sendToGA);
    onINP(sendToGA);
    onTTFB(sendToGA);
}
